/** The slot reservation countdown's messages beside the Book button. */
export const RESERVATION_TIMER_CONSTANTS = {
  MESSAGE_KEYS: {
    /** The reservation ran out; nothing was paid. */
    BOOKING_BLOCKED: 'reservation_timer.reservation_expired_booking_blocked',
    /** The reservation ran out while a payment was held for it: nothing was booked, the money goes back. */
    PAYMENT_REFUNDED: 'reservation_timer.reservation_expired_payment_refunded',
  },
} as const;
